import pckg from '../package.json';

export const DEAL_LIBRARY_VERSION = pckg.version;

export const GA_TRACKING_ID = 'G-V3WBW8WX8G';

export const GA_ORIGIN_DOMAIN = 'deals.openx.com';

export const GROWTHBOOK_SALT = 'qA&@?C7Zfp#DS88pWzKtdBiZXtK2z9a3o8cB';
export const GROWTHBOOK_NAME_ATTR = `${pckg.name}`;
